import type { StatItem } from '../../types/company-page';

type StatCardProps = Pick<StatItem, 'label' | 'value' | 'unit' | 'delta' | 'delta_label'>;

const StatCard = ({ label, value, unit, delta, delta_label }: StatCardProps) => {
  const hasDelta = delta !== undefined && delta !== null;
  const deltaClass =
    hasDelta && delta > 0
      ? 'stat-card__delta--positive'
      : hasDelta && delta < 0
        ? 'stat-card__delta--negative'
        : 'stat-card__delta--neutral';

  return (
    <div className="stat-card">
      <div className="stat-card__value">
        {value}
        {unit && <span className="stat-card__unit">{unit}</span>}
      </div>
      <div className="stat-card__label">{label}</div>
      {hasDelta && (
        <div className={`stat-card__delta ${deltaClass}`}>
          {delta_label ?? (delta > 0 ? `+${delta}` : String(delta))}
        </div>
      )}
    </div>
  );
};

export default StatCard;
